import { Dispatch } from 'redux';
import { aggregationsProps } from '../../../component/templates/Negotiation';
import {
  aggregationApi,
  AggregationApiRequest,
  convertResponseToSearchBranch,
  convertResponseToTableCells,
  SearchBranch,
} from '@common/external/AggregationApi';
import { actions } from '@common/redux/modules/Actions';
import { LoadingType, LOADING_TYPE } from '@common/redux/reducers/LoadingStatusReducer';
import { responseType } from '@common/utils/TableCells';
import { LINE_TYPE } from '@common/Common';
import { SORRY_MESSAGE_TYPE } from '@common/redux/reducers/SorryMessageReducer';
import { CommonResult } from '@common/external/Common';

/**
 * LINE_TYPE と LOADING_TYPE の対応表
 */
const mapLineTypesToLoadingType: {
  [key: string]: LoadingType;
} = {
  [LINE_TYPE.ACTION]: LOADING_TYPE.UNDER_NEGOTIATION,
  [LINE_TYPE.PENDING]: LOADING_TYPE.PENDING_NEGOTIATION,
  [LINE_TYPE.PERIOD]: LOADING_TYPE.UNDER_NEGOTIATION,
  [LINE_TYPE.PROB]: LOADING_TYPE.UNDER_NEGOTIATION,
  [LINE_TYPE.RESULT]: LOADING_TYPE.DONE_NEGOTIATION,
};

/**
 * 条件を受け取り、集約件数取得APIにアクセスし、結果をDispatchする
 * @param props APIに投げる条件
 * @param lineTypes 各タブのタイプリスト
 * @param statusType 集約カテゴリ
 * @param dispatch Dispatch
 */
export function updateAggregations(props: aggregationsProps, lineTypes: string[], statusType: string, dispatch: Dispatch) {
  lineTypes.forEach((lineType) => dispatch(actions.updateLoadingStatus.started(mapLineTypesToLoadingType[lineType])));

  makeAggregationsRequests(props, lineTypes, statusType).forEach((request) => {
    aggregationApi(request)
      .then((res) => {
        const { result, searchBranch, commodityCategoryContractInfo } = res;
        if (res.aggsNumber) {
          const tableCells: responseType = convertResponseToTableCells(res.aggsNumber);
          const searchBranchItem: { [key: string]: SearchBranch } = convertResponseToSearchBranch(res.aggsNumber);
          dispatchUpdateNegotiation(request.aggsType, tableCells, result, dispatch);
          dispatchUpdateSearchBranch(request.aggsType, searchBranchItem, dispatch);
          dispatch(actions.updateSearchBranch.status({ result: searchBranch }));
          dispatch(actions.updateSearchBranch.commodityCategoryContract(commodityCategoryContractInfo));
        }
        lineTypes.forEach((lineType) =>
          dispatch(
            actions.updateLoadingStatus.done({
              params: mapLineTypesToLoadingType[lineType],
              result,
            })
          )
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
        lineTypes.forEach((lineType) =>
          dispatch(
            actions.updateLoadingStatus.failed({
              params: mapLineTypesToLoadingType[lineType],
              error,
            })
          )
        );
      });
  });
}

/**
 * 集約件数取得APIのリクエストに変換する
 * @param props APIに投げる条件
 * @param lineTypes 各タブのタイプリスト
 * @param statusType 集約カテゴリ
 */
export function makeAggregationsRequests(props: aggregationsProps, lineTypes: string[], statusType: string): AggregationApiRequest[] {
  const aggregationsRequests: AggregationApiRequest[] = [];
  lineTypes.forEach((lineType) => {
    const aggregationsRequest: AggregationApiRequest = Object.assign({
      statusType: statusType,
      aggsType: lineType,
      userId: props.userId,
      agencyCd: props.agencyCd,
      searchConditionId: props.filterKey ? props.filterKey : 0,
    });
    aggregationsRequests.push(aggregationsRequest);
  });
  return aggregationsRequests;
}

/**
 * 商談件数画面におけるDispatch先を判定する
 * @param aggsType タブの種類
 * @param tableCells APIから返却された集約件数データ
 * @param dispatch Dispatch
 */
export function dispatchUpdateNegotiation(aggsType: string, tableCells: responseType, result: CommonResult, dispatch: Dispatch): void {
  switch (aggsType) {
    case LINE_TYPE.PERIOD:
      dispatch(actions.updateNegotiation.period(tableCells));
      break;
    case LINE_TYPE.ACTION:
      dispatch(actions.updateNegotiation.action(tableCells));
      break;
    case LINE_TYPE.PROB:
      dispatch(actions.updateNegotiation.prob(tableCells));
      break;
    case LINE_TYPE.PENDING:
      dispatch(actions.updateNegotiation.pending(tableCells));
      dispatch(actions.updateNegotiation.pendingHeaderDisp(result.jobDateTime));
      break;
    case LINE_TYPE.RESULT:
      dispatch(actions.updateNegotiation.result(tableCells));
      break;
  }
}

/**
 * 商談件数画面におけるDispatch先を判定する
 * @param aggsType タブの種類
 * @param searchBranchItem APIから返却された集約件数データ
 * @param dispatch Dispatch
 */
export function dispatchUpdateSearchBranch(aggsType: string, searchBranchItem: { [key: string]: SearchBranch }, dispatch: Dispatch): void {
  switch (aggsType) {
    case LINE_TYPE.PERIOD:
      dispatch(actions.updateSearchBranch.period(searchBranchItem));
      break;
    case LINE_TYPE.ACTION:
      dispatch(actions.updateSearchBranch.action(searchBranchItem));
      break;
    case LINE_TYPE.PROB:
      dispatch(actions.updateSearchBranch.prob(searchBranchItem));
      break;
    case LINE_TYPE.PENDING:
      dispatch(actions.updateSearchBranch.pending(searchBranchItem));
      break;
    case LINE_TYPE.RESULT:
      dispatch(actions.updateSearchBranch.result(searchBranchItem));
      break;
  }
}
